import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseRemove: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.25 4.5H15.5V4C15.5 2.61929 14.3807 1.5 13 1.5H11C9.61929 1.5 8.5 2.61929 8.5 4V4.5H4.75C3.50736 4.5 2.5 5.50736 2.5 6.75C2.5 7.90814 3.37501 8.86191 4.5 8.98627V19C4.5 20.933 6.067 22.5 8 22.5H16C17.933 22.5 19.5 20.933 19.5 19V8.98627C20.625 8.86191 21.5 7.90814 21.5 6.75C21.5 5.50736 20.4926 4.5 19.25 4.5ZM6 9H18V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V9ZM14 4.5H10V4C10 3.44772 10.4477 3 11 3H13C13.5523 3 14 3.44772 14 4V4.5ZM4 6.75C4 6.33579 4.33579 6 4.75 6H10H14H19.25C19.6642 6 20 6.33579 20 6.75C20 7.16421 19.6642 7.5 19.25 7.5H4.75C4.33579 7.5 4 7.16421 4 6.75ZM10.75 12C10.75 11.5858 10.4142 11.25 10 11.25C9.58579 11.25 9.25 11.5858 9.25 12V17C9.25 17.4142 9.58579 17.75 10 17.75C10.4142 17.75 10.75 17.4142 10.75 17V12ZM14.75 12C14.75 11.5858 14.4142 11.25 14 11.25C13.5858 11.25 13.25 11.5858 13.25 12V17C13.25 17.4142 13.5858 17.75 14 17.75C14.4142 17.75 14.75 17.4142 14.75 17V12Z"
        fill={color}
      />
    </svg>
  );
};
